import { createSlice } from '@reduxjs/toolkit';

const discourseSlice = createSlice({
  name: 'discourse',
  initialState: {
    stories: [],
    sentences:[],
    phrases:[],

    discourseData:[]

  },
  reducers: {
    setStories: (state, action) => {
      state.stories = action.payload;
    },
    setSentences: (state, action) => {
      state.sentences = action.payload;
    },
    setPhrases: (state, action) => {
      state.phrases = action.payload;
    },

    setDiscourseData: (state, action) => {
      state.discourseData = action.payload;
    },
  },
});

export const { setStories, setSentences,setPhrases , setDiscourseData} = discourseSlice.actions;

export default discourseSlice.reducer;
